module.exports = __webpack_public_path__ + "ca7c028a8a62ea48522fa881c5a22117.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/lankenau03.jpg
// module id = 518
// module chunks = 0